module.exports = __webpack_public_path__ + "img/sequence-suidobashi-sp@2x.dc41fd12.jpg";